<template>
    <div class="overall-bg">
        <b-container>
            <b-row>
                <b-col>
                    <BackBtn :goback="$router.back" />
                    <p v-if="paramValue == 'Grn Without Po'">
                        <Headerlayout headertext="Grn Without Po"></Headerlayout>
                    </p>
                    <p v-if="paramValue == 'Opening Stock'">
                        <Headerlayout headertext="Add Stock"></Headerlayout>
                    </p>
                </b-col>
            </b-row>
        </b-container>
    </div>

    <div class="form-white-bg">
        <b-container>
            <b-row>
                <b-row>
                    <b-col>
                        <Supplier :showone="paramValue" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6" md="8" sm="6">
                        <GRN :showone="paramValue" />
                    </b-col>
                    <b-col lg="6" md="8" sm="6">
                        <Invoice :showone="paramValue" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <Items :showone="paramValue" />
                    </b-col>
                </b-row>
                <b-row class="py-5">
                    <b-col>
                        <Table :columns="headers"></Table>
                    </b-col>
                </b-row>
                <Footer />
            </b-row>
        </b-container>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, PropType, computed } from 'vue'
import BackBtn from '../../../../components/FormComponents/BacktoMaster.vue'
import Headerlayout from '../../../../components/Masters/HeaderLayout.vue'
import Table from '../../../../components/FormComponents/Table.vue'
import Supplier from '../../../../modules/Inventory/components/Transaction/SupplierComponent.vue'
import Invoice from '../../../../modules/Inventory/components/Transaction/Invoice.vue'
import PurchaseOrder from '../../../../modules/Inventory/components/Transaction/PurchaseOrder.vue'
import GRN from '../../../../modules/Inventory/components/Transaction/stockin/grn.vue'

import Items from '../../../../modules/Inventory/components/Transaction/Item.vue'
import { useRoute } from 'vue-router';
import Footer from '../../../../components/FormComponents/Footer.vue'
export default defineComponent({
    components: {
        BackBtn,
        Headerlayout,
        Table,
        Supplier,
        Items,
        Footer,
        Invoice,
        PurchaseOrder,
        GRN
    },

    setup() {
        const route = useRoute();

        const paramValue = computed(() => {
            return route.query.param as string;
        });
        let List = ref([])
        const headers = [
            {
                header: 'Item',
                field: ''
            },
            {
                header: 'HSN',
                field: ''
            },
            {
                header: 'Item Name',
                field: ''
            },
            {
                header: 'Purchaseing Unit',
                field: ''
            },
            {
                header: 'PO Quantity',
                field: ''
            },
            {
                header: 'Qty',
                field: ''
            },
            {
                header: 'UOM',
                field: ''
            },
            {
                header: 'Unit Rate',
                field: ''
            },
            {
                header: 'Tax',
                field: ''
            },
            {
                header: 'Discount %',
                field: ''
            },
            {
                header: 'Discount Amount',
                field: ''
            },
            {
                header: 'Tax Value',
                field: ''
            },
            {
                header: 'Sales Unit',
                field: ''
            },
            {
                header: 'Sales Tax',
                field: ''
            },
            {
                header: 'Margin',
                field: ''
            },
            {
                header: 'Sales Price',
                field: ''
            },
            {
                header: 'MRP',
                field: ''
            },

        ];


        return {
            List,
            headers,
            paramValue
        }
    }

})
</script>

